import get from 'lodash/get'
import { default as deserialize, formatMeta } from 'app/utils/deserialize'
import { fetch } from 'app/utils/data'
import { buildFilters } from './utils'

export default {
  namespaced: true,

  state: {
    list: [],
    item: {
      audit: {}
    },
    pagination: {}
  },

  getters: {
    currentAudits: (state) => state.list,
    currentAudit: (state) => state.item,
    currentPagination: (state) => state.pagination
  },

  mutations: {
    auditsFetched(state, { audits }) {
      state.list = audits
    },

    auditFetched(state, { audit }) {
      state.item = audit
    },

    paginationFetched(state, { pagination }) {
      state.pagination = pagination
    }
  },

  actions: {
    async fetchAudits({ commit }, { page = 1, filters = {}, jsonFilters = {} }) {
      const response = await fetch({
        url: '/api/admin/audits',
        params: {
          page,
          ...buildFilters(filters),
          ...buildFilters(jsonFilters, 'jsonFilter')
        }
      })
      const audits = await deserialize(response.data)
      const pagination = formatMeta(get(response.data, 'meta', {}))

      commit('auditsFetched', { audits })
      commit('paginationFetched', { pagination })
    },

    async fetchAudit({ commit }, auditId) {
      const response = await fetch({ url: `/api/admin/audits/${auditId}` })
      const audit = await deserialize(response.data)

      commit('auditFetched', { audit })
    }
  }
}
